import { createContext } from 'react';
const RouterScrollProvider = createContext();
export default RouterScrollProvider;